import { useEffect, useState } from "react";
import * as Parse from "papaparse";
import { useAuth0 } from "@auth0/auth0-react";
import SplineApi from "../../tools/spline-api";

export default function useAAABenchmarkRawData(parserConfig = {}) {
  const [rawData, setRawData] = useState([]);
  const [loading, setLoading] = useState(false);
  const { getAccessTokenSilently } = useAuth0();

  const load = async function () {
    const token = await getAccessTokenSilently();
    const api = new SplineApi(token);

    try {
      setLoading(true);
      const csv = await api.getAAAData()
      setRawData(Parse.parse(csv, parserConfig).data);
    } catch (error) {}
    setLoading(false);
  };

  useEffect(() => {
    load();
  }, []);

  return { rawData, loading };
}
